import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tip from 'sites/views/tip';
import SendModal from 'sites/containers/pages/purchase-send';
import { getWalletBalanceOperation } from 'sites/state/modules/common/operations';
import {
   screenWidthSelector,
   isFetchingBalanceSelector,
   walletBalanceSelector,
} from 'sites/state/modules/common/selectors';
import { initTipOperation } from 'sites/state/modules/tip/operations';
import { setModalState } from 'sites/state/modules/tip/actions';
import { isFetchingSelector, tipDataSelector } from 'sites/state/modules/tip/selectors';
import { setSendModalState } from 'sites/state/modules/purchase-send/actions';
import {
   isOpenSendModalSelector,
   savedPaymentDataSelector,
   modalKeySelector,
   modalTypeSelector,
   paymentButtonLoadingSelector,
   contentDataSelector,
} from 'sites/state/modules/purchase-send/selectors';
import { fetchPurchaseMethodsOperation } from 'sites/state/modules/purchase-send/operations';
import { activePurchaseSelector } from 'sites/state/modules/purchase/selectors';
import { choosePurchaseCompleted } from 'sites/state/modules/purchase/actions';
import {
   purchaseOptions,
} from 'sites/state/modules/purchase/operations';
import { initWalletOperation } from 'sites/state/modules/wallet/operations';
import {

   setWalletLimitState,
} from 'sites/state/modules/wallet/actions';
import {
   isFetchingSelector as isFetchingWalletSelector,
   amountDataSelector,
   walletLimitModalDataSelector,
} from 'sites/state/modules/wallet/selectors';
import {
   onClickChat,
   setChatPanelAction,
} from 'sites/state/modules/chat/actions';
import { chatPanelSelector } from 'sites/state/modules/chat/selectors';
import ChatHepler from 'common/utils/chat';
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';
import QueryParams from 'sites/utils/QueryParams';
import { siteInfoSelector } from 'admin/state/modules/common/selectors';

class TipMeContainer extends Component {

   static propTypes = {
      screenWidth: PropTypes.number,
      goTo: PropTypes.func,
      initTip: PropTypes.func,
      tipModalData: PropTypes.object,
      setModalState: PropTypes.func,
      isFetching: PropTypes.bool,
      tipData: PropTypes.array,
      onClickChat: PropTypes.func,
      chatPanel: PropTypes.object,
      setChatPanel: PropTypes.func,
      initWallet: PropTypes.func,
      setSendModalState: PropTypes.func,
      amountData: PropTypes.array,
      isFetchingWallet: PropTypes.bool,
      isOpenSendModal: PropTypes.bool,
      modalKey: PropTypes.string,
      modalType: PropTypes.string,
      savedPaymentData: PropTypes.object,
      onClickPayment: PropTypes.func,
      getWalletBalance: PropTypes.func,
      isFetchingBalance: PropTypes.bool,
      walletLimitModalData: PropTypes.object,
      fetchPurchaseMethods: PropTypes.func,
      paymentButtonLoading: PropTypes.bool,
      setWalletLimitState: PropTypes.func,
      walletBalance: PropTypes.number,
      contentData: PropTypes.object,
      siteInfo: PropTypes.object,
   };

   constructor(props) {
      super(props);
      this.state = {
         tipModalData: this.props.tipModalData,
         height: null,
         id: null,
         animateTip: 'up',
         animateSend: 'up',
         animateLimit: 'up',
         isAddProcessingFees: true,
         isClickTip: false,
      };
      this.timerFetching = null
   }

   componentDidMount(){
      const { initTip, tipModalData, isFetching, modalKey, setSendModalState } = this.props;
      const params = QueryParams.getParsedSearchParams();
      if(params && params['open-top-up'] === 'true') {
         if(params['modal-key'] === 'top_up') {
            setSendModalState({ modalKey: 'top_up', modalType: 'tip' });
         }
      }
      this.setState({ height: window.innerHeight });
      if(tipModalData.isInitTip && !isFetching && modalKey === 'tip'){
         initTip()
      }

   }

   componentWillUnmount() {
      const { setSendModalState } = this.props;
      setSendModalState({ contentData: {} });
      clearTimeout(this.timerFetching);
   }

   onTipMeModalClose = (data) => {
      QueryParams.removeQueryParam('open-top-up');
      QueryParams.removeQueryParam('modal-key');
      const { setModalState, setSendModalState, screenWidth } = this.props;
      this.setState({ animateTip: 'down' });
      if(screenWidth < 701) {
         this.timerFetching = setTimeout(() => {
            setSendModalState({ modalKey: 'tip' });
            setModalState({ ...data, extraInfo: null });
         }, 800)
      } else {
         setSendModalState({ modalKey: 'tip' });
         setModalState({ ...data, extraInfo: null });
      }
   }

   onCloseChatModal = () => {

      const {
         onClickChat,
         setChatPanel,
         chatPanel,
         screenWidth,
      } = this.props
      if(chatPanel.isOpen) {
         onClickChat(false)
         let chatpanelData = {
            isMobile: screenWidth < 1025,
            isOpen: !chatPanel.isOpen,
         }
         setChatPanel({ ...chatpanelData })
         if(screenWidth > 1024) {
            ChatHepler.inputState(false)
         }
      }
   }

   topUpMyWallet = () => {
      const { initWallet, setSendModalState, getWalletBalance, tipModalData } = this.props;
      if(tipModalData?.extraInfo && 'live_stream' ===  tipModalData.extraInfo?.tip_type){
         window.wallet_referrer_url = {
            route_name: 'LIVE_STREAM_STUDIO',
            page_name: 'livestream',
            url: window.location.href,
         }
      } else {
         window.wallet_referrer_url = null;
      }
      getWalletBalance();
      setSendModalState({ modalKey: 'top_up' });
      initWallet()
   }

   onCloseSendModal = (bool) => {
      const { setSendModalState } = this.props;
      setSendModalState({ isOpenSendModal: bool })
   }

   goToWalletTopUp = () => {
      const { setSendModalState, setModalState, screenWidth } = this.props;
      setTimeout(() => {
         this.setState({ animateSend: 'down' });
         if(screenWidth < 701) {
            this.timerFetching = setTimeout(() => {
               setSendModalState({ isOpenSendModal: false, isSend: false, isNotEnoughtBalance: false, modalKey: 'top_up' });
               setModalState({ 'isTipModal': true });
            }, 800)
         } else {
            setSendModalState({ isOpenSendModal: false, isSend: false, isNotEnoughtBalance: false, modalKey: 'top_up' });
            setModalState({ 'isTipModal': true });
         }
      }, 100)
      this.topUpMyWallet();
   }

   tipMe = async (id, _, extraInfo) => {
      const {
         modalKey,
         fetchPurchaseMethods,
      } = this.props;
      this.setState({ id, isClickTip: true });
      let type = 'tip';
      let itemId = id
      if('top_up' === modalKey) {
         itemId = id.id
         type = 'wallet'
      }
      const { isAddProcessingFees } = this.state
      const price = 'top_up' === modalKey && id ? id.amount : id
      const  onlyWalletPay = price < 4
      fetchPurchaseMethods(itemId, type, isAddProcessingFees, onlyWalletPay)
   }

   onContinue = (type) => {
      const { setSendModalState, setModalState, savedPaymentData, onClickPayment } = this.props;
      if(type === 'wallet') {
         setSendModalState({ isOpenChoosePaymentModal: false, isOpenSendModal: true });
      }
      if(type === 'card') {
         setSendModalState({ isOpenChoosePaymentModal: false });
         setModalState({ isTipModal: false });
         if(savedPaymentData && savedPaymentData.isSaved) {
            let data = {
               payment_method: savedPaymentData.payment_method,
               id: savedPaymentData.id,
               payment_system: savedPaymentData.payment_system,
               type: savedPaymentData.type,
            }
            onClickPayment(data);
         } else {
            this.chooseAnotherPayment();
         }
      }
      if(type === 'paypal') {
         console.log('This payment method supported only Frisky Business');
      }
   }

   chooseAnotherPayment = () => {
      const { goTo } = this.props;
      const { id } = this.state;
      goTo(Router.route('PURCHASE_TIP').getCompiledPath({ id }))
   }

   onChangeAddProcessingFees = (name, value) => {
      this.setState({ isAddProcessingFees: value })
   }

   onWalletModalClose = () => {
      const { setWalletLimitState, screenWidth } = this.props;
      this.setState({ animateLimit: 'down' });
      if(screenWidth < 701) {
         this.timerFetching = setTimeout(() => {
            setWalletLimitState({ isLimitModal: false })
         }, 800)
      } else {
         setWalletLimitState({ isLimitModal: false })
      }
   }

   render() {
      const {
         screenWidth,
         tipData,
         isFetching,
         amountData,
         isFetchingWallet,
         isOpenSendModal,
         modalKey,
         modalType,
         isFetchingBalance,
         walletLimitModalData,
         paymentButtonLoading,
         walletBalance,
         tipModalData,
         contentData,
         setSendModalState,
         siteInfo,
      } = this.props
      const {
         height,
         id,
         animateTip,
         animateSend,
         isAddProcessingFees,
         isClickTip,
      } = this.state;
      let type = 'top_up' === modalKey ? 'wallet' : 'tip';
      return (
         <>
            <Tip
               isFetching={ (isFetching || (isFetchingBalance && !isClickTip)) }
               isFetchingWallet={ isFetchingWallet || isFetchingBalance }
               tipData={ tipData }
               walletData={ amountData }
               type={ modalKey }
               id={ 'top_up' === modalKey && id ?  id.id : id }
               tipMe={ this.tipMe }
               onModalClose={ () => this.onTipMeModalClose({ isTipModal: false }) }
               topUpMyWallet={ this.topUpMyWallet }
               isMobile={ screenWidth < 701 }
               height={ height }
               balance={ walletBalance }
               animateTip={ animateTip }
               onChangeAddProcessingFees={ this.onChangeAddProcessingFees }
               isAddProcessingFees={ isAddProcessingFees }
               isFetchingBalance={ isFetchingBalance || walletLimitModalData.isFetching }
               paymentButtonLoading={ paymentButtonLoading }
               extraInfo={ tipModalData?.extraInfo }
               tipContentData={ contentData }
               setSendPurchase={ setSendModalState }
               siteOwnerName={ siteInfo.admin_screen_name }
            />
            {
               (isOpenSendModal && modalType === type && (isClickTip || !isFetchingBalance)) && (
                  <SendModal
                     isGoBack={ true }
                     id={ 'top_up' === modalKey && id ? id.id : id }
                     usdTerms={ 'top_up' === modalKey && id ? id.amount : id }
                     type={ 'top_up' === modalKey ? 'wallet' : 'tip' }
                     animateSend={ animateSend }
                     onCloseSendModal={ (bool) => this.onCloseSendModal(bool) }
                     goToWalletTopUp={ this.goToWalletTopUp }
                     modalKey={ modalKey }
                     isAddProcessingFees={ isAddProcessingFees }
                     extraInfo={ tipModalData?.extraInfo }
                  />
               )
            }
         </>
      );
   }
}


const mapStatesToProps = state => ({
   screenWidth: screenWidthSelector(state),
   tipData: tipDataSelector(state),
   isFetching: isFetchingSelector(state),
   chatPanel: chatPanelSelector(state),
   activePurchase: activePurchaseSelector(state),
   amountData: amountDataSelector(state),
   isFetchingWallet: isFetchingWalletSelector(state),
   isOpenSendModal: isOpenSendModalSelector(state),
   savedPaymentData: savedPaymentDataSelector(state),
   modalKey: modalKeySelector(state),
   modalType: modalTypeSelector(state),
   isFetchingBalance: isFetchingBalanceSelector(state),
   walletLimitModalData: walletLimitModalDataSelector(state),
   paymentButtonLoading: paymentButtonLoadingSelector(state),
   walletBalance: walletBalanceSelector(state),
   contentData: contentDataSelector(state),
   siteInfo: siteInfoSelector(state),
});

const mapDispatchToProps = dispatch => ({
   initTip: (params) => { dispatch(initTipOperation(params)) },
   initWallet: () => dispatch(initWalletOperation()),
   setModalState: (data) => { dispatch(setModalState(data)) },
   setSendModalState: (data) => { dispatch(setSendModalState(data)) },
   onClickChat: bool => dispatch(onClickChat(bool)),
   onClickPayment: (data) => dispatch(purchaseOptions(data)),
   setChatPanel: data => {
      dispatch(setChatPanelAction(data))
   },
   choosePurchaseCompleted: data => {
      dispatch(choosePurchaseCompleted(data))
   },
   getWalletBalance: () => { dispatch(getWalletBalanceOperation()) },
   setWalletLimitState: (data) => { dispatch(setWalletLimitState(data)) },
   goTo: (path, search) => {
      dispatch(push({
         pathname: path,
         search,
      }))
   },
   fetchPurchaseMethods: (id, type, isAddProcessingFees, onlyWalletPay) => dispatch(fetchPurchaseMethodsOperation(type, id, null, onlyWalletPay, isAddProcessingFees)),
})
export default connect(mapStatesToProps, mapDispatchToProps)(TipMeContainer);
